import type { JobRunKind } from "./jobRun.types";
import { jobRunBuildOrderLineReport } from "./job-run-build-order-line-report/jobRunBuildOrderLineReport.kind";
import { jobRunBuildSnapshot } from "./job-run-build-snapshot/jobRunBuildSnapshot.kind";
import { jobRunImportOrderStatuses } from "./job-run-import-order-statuses/jobRunImportOrderStatuses.kind";
import { jobRunPullEstoreInventory } from "./job-run-pull-estore-inventory/jobRunPullEstoreInventory.kind";

/** The job kinds that can be run from the run drawer, each with its own settings. A kind not listed here isn't offered. */
export const JOB_RUN_KINDS: Record<string, JobRunKind> = {
  buildSnapshot: jobRunBuildSnapshot,
  importOrderStatuses: jobRunImportOrderStatuses,
  pullEstoreInventory: jobRunPullEstoreInventory,
  buildOrderLineReport: jobRunBuildOrderLineReport,
};
